var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 96,
    viewBox: "0 0 88 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logistics_svg__filter0_d_511_5936)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#logistics_svg__paint0_linear_511_5936)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#logistics_svg__paint1_linear_511_5936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5536 25.104L63.994 35.4764C63.998 35.5056 64 35.5348 64 35.5644V54.72C64 55.4268 63.4268 56 62.72 56H33.28C32.5732 56 32 55.4268 32 54.72V35.5644C32 35.5348 32.002 35.5056 32.006 35.4764L33.4464 25.104C33.5344 24.4712 34.0752 24 34.7144 24H61.2856C61.9248 24 62.466 24.4712 62.5536 25.104ZM61.1204 38.4H34.88V53.12H61.1204V38.4ZM58.2403 48C58.4171 48 58.5603 48.1432 58.5603 48.32V50.24C58.5603 50.4168 58.4171 50.56 58.2403 50.56H46.0802C45.9034 50.56 45.7602 50.4168 45.7602 50.24V48.32C45.7602 48.1432 45.9034 48 46.0802 48H58.2403ZM58.2403 42.88C58.4171 42.88 58.5603 43.0232 58.5603 43.2V45.12C58.5603 45.2968 58.4171 45.44 58.2403 45.44H50.8802C50.7034 45.44 50.5602 45.2968 50.5602 45.12V43.2C50.5602 43.0232 50.7034 42.88 50.8802 42.88H58.2403ZM46.7202 26.88H36.1077L34.9076 35.52H46.7202V26.88ZM59.8927 26.88H49.2802V35.52H61.0928L59.8927 26.88Z",
    fill: "url(#logistics_svg__paint2_linear_511_5936)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logistics_svg__paint0_linear_511_5936",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logistics_svg__paint1_linear_511_5936",
    x1: 48,
    y1: 0,
    x2: 27.5,
    y2: 70.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logistics_svg__paint2_linear_511_5936",
    x1: 48,
    y1: 24,
    x2: 48,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA22A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logistics_svg__filter0_d_511_5936",
    x: 0,
    y: 0,
    width: 88,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.931969 0 0 0 0 0.931969 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_511_5936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_511_5936",
    result: "shape"
  })))));
}

export default SvgLogistics;